import React from 'react';
import './Contact.css';

const Contact = () => {

  return (
    <div className="contact">
      <div className="container">
        {/* Header */}
        <div className="contact-header">
          <h1>Get in Touch</h1>
          <p>Ready to begin your journey? I'm here to help you take the first step.</p>
        </div>

        {/* Contact Information */}
        <div className="contact-info">
          <h2>Contact Information</h2>
          <div className="info-grid">
            <div className="info-item">
              <div className="info-icon">📧</div>
              <div className="info-content">
                <h3>Email</h3>
                <p>alicia@counselingwellbeing.net</p>
                <p className="info-note">I typically respond within 24 hours during business hours.</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">📱</div>
              <div className="info-content">
                <h3>Phone (call or text)</h3>
                <p>512.688.6372</p>
                <p className="info-note">Available Mon-Thur, 9 AM - 5 PM</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">📍</div>
              <div className="info-content">
                <h3>Location</h3>
                <p>Austin,Texas 78757</p>
                <p>Services include the entire state of Texas</p>
                <p className="info-note">Virtual sessions only</p>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Information */}
        <div className="additional-info">
          <h2>What to Expect</h2>
          <div className="expectations-grid">
            <div className="expectation-card">
              <h3>Initial Response</h3>
              <p>I'll respond to your message within 24 hours to schedule a consultation call.</p>
            </div>
            <div className="expectation-card">
              <h3>Consultation Call</h3>
              <p>A free 15-minute phone consultation to discuss your needs and answer questions.</p>
            </div>
            <div className="expectation-card">
              <h3>First Session</h3>
              <p>We'll meet for an initial session to discuss your goals and create a treatment plan.</p>
            </div>
          </div>
        </div>

        {/* Emergency Notice */}
        <div className="emergency-notice">
          <h3>🆘 Emergency or Crisis?</h3>
          <p>If you're experiencing a mental health crisis or emergency, please contact emergency services immediately:</p>
          <div className="emergency-contacts">
            <a href="tel:911" className="emergency-button">Call 911</a>
            <a href="tel:988" className="emergency-button">Suicide Prevention Lifeline: 988</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
